/**
 * Created by mgoria on 11/09/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PutCognitoRecordException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when put a new record to a CognitoSync dataset failed
 */
let PutCognitoRecordException = exports.PutCognitoRecordException = function (_Exception) {
  _inherits(PutCognitoRecordException, _Exception);

  /**
   * @param {String} dataset
   * @param {String} record
   * @param {Object} error
   */
  function PutCognitoRecordException(dataset, record, error) {
    _classCallCheck(this, PutCognitoRecordException);

    return _possibleConstructorReturn(this, (PutCognitoRecordException.__proto__ || Object.getPrototypeOf(PutCognitoRecordException)).call(this, `Error on putting "${record}" record into "${dataset}" dataset. ${error}`));
  }

  return PutCognitoRecordException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/PutCognitoRecordException.js
// module id = 443
// module chunks = 0